import React, { useState, useEffect } from "react";
import { trackButtonClick } from "../../services/googleSheetsService";

import Cupon1_Akiwei from "../../assets/images/akiwei-img.png";
import Cupon2_Compressport from "../../assets/images/compressport-img.jpeg";
import Cupon3_UpSport from "../../assets/images/up-sports-img.png";
import Cupon4_heart from "../../assets/images/Cupon4_heart.png";
import Cupon5_goldenarmour from "../../assets/images/Cupon5_GOLDENARMOUR.png";
import Cupon6_fav from "../../assets/images/Coupon6_Fav.jpg";
import Cupon7_mrVc from "../../assets/images/Cupon7_mrVc.png";

const cuponCard_data = [
    {
        img: `${Cupon1_Akiwei}`,
        title: "AKIWEI",
        boothNum: "# 323",
        content1: "這裡可以找到喵喵本人～",
        content2: "跟喵喵分享你的配速計算，即可現享喵喵價及優惠券",
    },
    {
        img: `${Cupon3_UpSport}`,
        title: "UP-Sport",
        boothNum: "# 323",
        content1: "最懂你也最懂喵喵的運動補給！",
        content2: "在臉書或IG分享配速計算截圖並tag @upsports.tw，結帳即享試吃包。",
    },
    {
        img: `${Cupon2_Compressport}`,
        title: "COMPRESSPORT",
        boothNum: "# 246",
        content1: "喵喵最喜歡的裝備就在這！",
        content2: "結帳出示「喵喵問個痛」配速計算結果，官網折價券等你拿～",
    },
    {
        img: `${Cupon4_heart}`,
        title: "堅心",
        boothNum: "# 207",
        content1: "這裡有喵喵愛用的眠易復~",
        content2: "跟毛闆說「喵喵問個痛」，完成任務即可獲得運動人專屬的「食動力」 運動益生菌！",
    },
    {
        img: `${Cupon5_goldenarmour}`,
        title: "GA黃金甲",
        boothNum: "# 112",
        content1: "喵喵日常保養跟運動促進都推薦！",
        content2: "出示配速結果，追蹤享試吃、喊聲享折扣！",
    },
    {
        img: `${Cupon6_fav}`,
        title: "FAV運動傷害預防專家",
        boothNum: "# 131",
        content1: "人人喵喵都該有的運動乳霜！小紫是防抽筋神器喔！",
        content2: "結帳時出示「喵喵問個痛」配速畫面，就送試用包（隨機不挑款）～",
    },
    // { img: `${Cupon7_mrVc}`, title: "MRVC身體優化工作室", boothNum: "#", content1: "喵喵狂推的運動按摩！", content2: "沒在博覽會但是憑配速計算結果截圖預約，12/31前享優惠價！" },
];

function ExpoCuponCard() {
    const [stamps, setStamps] = useState(
        JSON.parse(localStorage.getItem("stamps")) || Array(cuponCard_data.length).fill(false)
    );

    const handleClick = (index) => {
        const updatedStamps = [...stamps];
        updatedStamps[index] = !updatedStamps[index];
        setStamps(updatedStamps);
        trackButtonClick("博覽會優惠-點擊卡片", cuponCard_data[index].title);
    };
    useEffect(() => {
        localStorage.setItem("stamps", JSON.stringify(stamps));
    }, [stamps]);

    return (
        <>
            <div className={`cupon-wrap`}>
                {cuponCard_data.map((item, index) => (
                    <div
                        key={index}
                        className={`cuponCard-wrap ${stamps[index] ? "stamped" : ""}`}
                        onClick={() => handleClick(index)}
                    >
                        {stamps[index] && (
                            <div className="stamp">
                                <div className="stamp-text">已兌換</div>
                            </div>
                        )}
                        <div className="cuponImg-wrap">
                            <img src={item.img} alt={`${item.title}的形象照片`} />
                        </div>
                        <div className="cuponContent-wrap">
                            <div className="title-wrap">
                                <div className="titile">{item.title}</div>
                                <div className="booth-number">{item.boothNum}</div>
                            </div>
                            <div className="content">{item.content1}</div>
                            <div className="content">{item.content2}</div>
                        </div>
                    </div>
                ))}

                <div className={`cuponCard-wrap `}>
                    <a
                        href="https://www.instagram.com/muscle_relaxer_vc/"
                        title="MRVC身體優化工作室的形象照片官方連結"
                        onClick={() =>
                            trackButtonClick(
                                "博覽會優惠-MRVC連結",
                                "https://www.instagram.com/muscle_relaxer_vc/"
                            )
                        }
                    >
                        <div className="cuponImg-wrap">
                            <img src={Cupon7_mrVc} alt={`MRVC身體優化工作室的形象照片`} />
                        </div>
                        <div className="cuponContent-wrap">
                            <div className="title-wrap">
                                <div className="titile">MRVC身體優化工作室</div>
                                <div className="booth-number">#</div>
                            </div>
                            <div className="content">喵喵狂推的運動按摩！</div>
                            <div className="content">
                                沒在博覽會但是憑配速計算結果截圖預約，12/31前享優惠價！
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </>
    );
}

export default ExpoCuponCard;
